// --------------------------------------------------------------
// Created On: 2022-07-27
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single asset that is pending transfer.
export default function OutgoingTransferAssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="outgoing-transfer-row">
      <span>Asset &apos;</span>

      <b>{props.name}</b>

      <span>&apos; is awaiting acceptance from &apos;</span>

      <b>{props.companyName}</b>

      <span>&apos;</span>
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  companyName: string;
}
